<bp-hl-area-container name="Kurzprotokoll">
	<div class="touch-form">
		<!-- Gruppe 1: Punktart, Kartierer, Datum -->
		<div class="form-row">
			<div class="form-label-cell">Punktart</div>
			<div class="form-input-cell">
				<wd-typeahead [(model)]="data.type" name="Punktart" [filter]="punktartFilter()"></wd-typeahead>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Kartierer</div>
			<div class="form-input-cell">
				<wd-text-input *ngIf="canSeePersonalData()" name="Kartierer" [(model)]="data.header.aufnahme.kartierer" nonEmpty></wd-text-input>
				<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Aufnahmedatum</div>
			<div class="form-input-cell">
				<wd-date-input *ngIf="canSeePersonalData()" name="Aufnahmedatum" [(model)]="data.header.aufnahme.datum" nonEmpty></wd-date-input>
				<span *ngIf="!canSeePersonalData()" class="masked-value">–</span>
			</div>
		</div>

		<!-- Gruppe 2: Adresse -->
		<div class="form-section-header">Adresse</div>
		<div class="form-row">
			<div class="form-label-cell">Forstamt/Revier</div>
			<div class="form-input-cell multi">
				<wd-typeahead [(model)]="data.header.forstamt" name="Forstamt"></wd-typeahead>
				<span class="inline-label centered">/</span>
				<wd-typeahead [(model)]="data.header.revier" name="Revier"></wd-typeahead>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Abteilung/UA/TF</div>
			<div class="form-input-cell multi">
				<wd-text-input name="Abteilung" [(model)]="data.header.adresse.abteilung"></wd-text-input>
				<wd-typeahead [(model)]="data.header.adresse.unterabteilung" name="Unterabteilung"></wd-typeahead>
				<wd-text-input name="Teilfläche" [(model)]="data.header.adresse.teilflaeche"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Gemarkung/Flur/Flst</div>
			<div class="form-input-cell multi">
				<wd-text-input name="Gemarkung" [(model)]="data.header.adresse.gemarkung"></wd-text-input>
				<wd-number-input name="Flur" [(model)]="data.header.adresse.flur"></wd-number-input>
				<wd-text-input name="Flurstück" [(model)]="data.header.adresse.flurstueck"></wd-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Forstbetrieb</div>
			<div class="form-input-cell">
				<wd-text-input name="Forstbetrieb" [(model)]="data.header.forstbetrieb"></wd-text-input>
			</div>
		</div>

		<!-- Gruppe 3: Befund -->
		<div class="form-section-header">Befund</div>
		<div class="form-row">
			<div class="form-label-cell">HBF</div>
			<div class="form-input-cell multi">
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<wd-typeahead [(model)]="bf.hbf" name="Hauptbodenform[i]" placement="bottom" [acceptOtherValues]="true"></wd-typeahead>
				</ng-container>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">FBF</div>
			<div class="form-input-cell multi">
				<wd-text-input [(model)]="data.header.bodenform.prefix" label="Präfix" name="FBFPrefix"></wd-text-input>
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<wd-typeahead [(model)]="bf.fbf" label="Feinbodenform" name="Feinbodenform[i]" [filter]="feinbodenformFilter(bf.hbf)" [hbfFilter]="bf.hbf" (hbfSelected)="bf.hbf = $event" [acceptOtherValues]="true" [otherValuesRegex]="moorFBFRegex" [otherValuesRegexMessage]="moorFBFRegexMessage" [extraSuggestions]="moorFBFSuggestions"></wd-typeahead>
					<div *ngIf="i === data.header.bodenform.bf.length - 1" class="btn-group">
						<button *ngIf="i > 0" class="btn btn-danger btn-sm" (click)="removeFeinbodenform()"><bi name="trash"></bi></button>
						<button *ngIf="canAddFeinbodenform()" class="btn btn-info btn-sm" (click)="addFeinbodenform()"><bi name="plus"></bi></button>
					</div>
				</ng-container>
				<wd-typeahead [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="bottom" [acceptOtherValues]="true"></wd-typeahead>
				<wd-text-input name="Wasserform2" label="Stauwasserf." [(model)]="data.header.wasserstufe2" [superscript]="true"></wd-text-input>
				<span class="inline-label">/</span>
				<wd-text-input name="Wasserform" label="Grundwasserf." [(model)]="data.header.wasserstufe" [superscript]="true"></wd-text-input>
				<wd-list-input name="Mesoklima" label="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Humusform</div>
			<div class="form-input-cell">
				<wd-typeahead name="HumusformNeu" [(model)]="data.header.humusform.aufnahmeFlaeche.neu" [acceptOtherValues]="true"></wd-typeahead>
			</div>
		</div>

		<!-- Gruppe 4: Bemerkungen -->
		<div class="form-section-header">Bemerkungen</div>
		<div class="form-row">
			<div class="form-label-cell">Bemerkungen</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
